<template>
  <b-container class="home-carousel" fluid>
    <div
      :class="[
        actives ? 'banner-img banner-img-product' : 'banner-img',
        'video-hight'
      ]"
    >
      <video
        src="@/assets/video/banner.mp4"
        muted="muted"
        controls="controls"
        preload="meta"
        loop="loop"
        autoplay="autoplay"
      ></video>
      <div class="banner-text banner-video container">
        <h1>{{ title }}</h1>
        <p>{{ text }}</p>
        <p style="margin-top:5px">{{ textTwo }}</p>
        <b-button variant="primary" class="video-button" @click="link">
          入汇吧
          <b-icon-arrow-right></b-icon-arrow-right>
        </b-button>
      </div>
    </div>
  </b-container>
</template>
<script>
export default {
  name: "banners",
  data() {
    return {
      actives: false
    };
  },
  watch: {
    $route: "headerChange"
  },
  props: {
    src: {
      type: String
    },
    title: {
      type: String
    },
    text: {
      type: String
    },
    textTwo: {
      type: String
    },
    link: {
      type: Function
    }
  },
  method: {
    headerChange() {
      const routers = this.$route.path;
      if (routers.indexOf("product") > -1) {
        this.actives = true;
      } else {
        this.actives = false;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.home-carousel {
  padding: 0;
}
</style>
